import React from "react";
import { notImplemented } from "../../utils";
import ChangeDetailsLeftCard from "./ChangeDetailsLeftCard";
import ChangeDetailsRightCard from "./ChangeDetailsRightCard";

function ChangeDetailsInfoSection() {

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card oct_main-card">
                        <div className="card-header">
                            <h2 className="card-title">Change Details</h2>
                            <div className="card-tools">
                                <div onClick={() => notImplemented()} className="oct_card-btn btn oct_btn-secondary">
                                    Print Report
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="mb-4 col-xl-6 d-flex mb-xl-0">
                                    <ChangeDetailsLeftCard />
                                </div>
                                <div className="col-xl-6 d-flex">
                                    <ChangeDetailsRightCard />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default ChangeDetailsInfoSection;